import React from 'react';
import { useThemeClasses } from '../../lib/themes/utils';

const SectionTitle = ({ children }: { children: React.ReactNode }) => {
  const theme = useThemeClasses();
  
  return (
    <div className="mb-8">
      <h2 className={`
        text-2xl sm:text-3xl 
        ${theme.typography.headingLarge}
        mb-4
        relative
        inline-block
      `}>
        {children}
        <div className={`
          absolute -bottom-2 left-0 h-1 w-full 
          ${theme.backgrounds.gradientPrimary} 
          ${theme.radius.full}
          opacity-80
        `}></div>
      </h2>
      <div className="flex items-center space-x-2 mb-2">
        <div className={`w-2 h-2 ${theme.backgrounds.primary} ${theme.radius.full}`}></div>
        <div className={`w-1 h-1 ${theme.backgrounds.secondary} ${theme.radius.full}`}></div>
        <div className={`w-1 h-1 ${theme.backgrounds.primary} opacity-60 ${theme.radius.full}`}></div>
      </div>
    </div>
  );
};

export default SectionTitle;
